import { gql } from "@apollo/client";

export const QR_LIST_REVIEW = gql`
  query QR_LIST_REVIEW($paginationParams: BaseCollection!, $tripPublicationId: String!) {
    QR_LIST_REVIEW(paginationParams: $paginationParams, tripPublicationId: $tripPublicationId) {
      code
      error {
        message
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          globalMark
          complianceMark
          qualityServiceMark
          priceQualityMark
          opinions {
            id
            ownerId
            clientId
            firstName
            lastName
            picture
            globalMark
            complianceMark
            qualityServiceMark
            priceQualityMark
            comment
            createdDate
          }
        }
      }
    }
  }
`;

export const QR_GET_REVIEW_RATING_DISTRIBUTION = gql`
  query QR_GET_REVIEW_RATING_DISTRIBUTION($tripPublicationId: String!) {
    QR_GET_REVIEW_RATING_DISTRIBUTION(tripPublicationId: $tripPublicationId) {
      code
      error {
        message
        correlationId
      }
      data {
        totalElements
        counts {
          stars
          count
        }
      }
    }
  }
`;

export const MT_ADD_TRIP_OPINION = gql`
  mutation MT_ADD_REVIEW($tripOpinionInput: TripOpinionInput!) {
    MT_ADD_TRIP_OPINION(tripOpinionInput: $tripOpinionInput) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        globalMark
      }
    }
  }
`;
